import React, { useState, useEffect } from "react";
import { appleImg, bagImg, searchImg } from "../utils";
import { navLists } from "../constants";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Sayfa kaydırıldığında arka planı belirginleştir (Apple tarzı)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 border-b ${
        isScrolled
          ? "py-3 bg-black/80 backdrop-blur-md border-white/10"
          : "py-5 bg-transparent border-transparent"
      }`}
    >
      <nav className="flex w-full max-w-7xl mx-auto px-6 lg:px-12 items-center relative">
        {/* Logo Bölümü */}
        <div className="flex items-center gap-2 group cursor-pointer">
          <img
            src={appleImg}
            alt="566dev"
            width={16}
            height={20}
            className="brightness-125 group-hover:scale-110 transition-transform duration-300"
          />
          <span className="text-white font-medium tracking-tight text-lg hidden sm:block">
            Apple
          </span>
        </div>

        {/* Desktop Navigasyon - Orta Bölüm */}
        <div className="flex flex-1 justify-center max-md:hidden">
          {navLists.map((nav) => (
            <a
              key={nav}
              href={`#${nav.toLowerCase()}`}
              className="px-6 text-[13px] font-normal cursor-pointer text-zinc-400 hover:text-white transition-all duration-300"
            >
              {nav}
            </a>
          ))}
        </div>

        {/* Sağ Taraf - İkonlar & Mobil Tetikleyici */}
        <div className="flex items-center gap-6 md:gap-8 max-md:justify-end max-md:flex-1">
          {/* Arama Butonu */}
          <button className="opacity-80 hover:opacity-100 transition-opacity">
            <img src={searchImg} alt="search" width={18} height={18} />
          </button>

          {/* Sepet Butonu */}
          <button className="opacity-80 hover:opacity-100 transition-opacity relative">
            <img src={bagImg} alt="bag" width={18} height={18} />
            <span className="absolute -top-1 -right-2 bg-blue-600 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">
              0
            </span>
          </button>

          {/* Mobil Hamburger Menü Butonu */}
          <button
            className="md:hidden flex flex-col gap-1.5 z-50"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span
              className={`w-6 h-0.5 bg-white transition-all ${isMenuOpen ? "rotate-45 translate-y-2" : ""}`}
            />
            <span
              className={`w-6 h-0.5 bg-white transition-all ${isMenuOpen ? "opacity-0" : ""}`}
            />
            <span
              className={`w-6 h-0.5 bg-white transition-all ${isMenuOpen ? "-rotate-45 -translate-y-2" : ""}`}
            />
          </button>
        </div>

        {/* Mobil Menü Overlay (Tam Ekran) */}
        <div
          className={`fixed inset-0 bg-black z-40 flex flex-col items-start justify-start pt-24 px-10 transition-all duration-500 ease-in-out md:hidden ${
            isMenuOpen
              ? "opacity-100 pointer-events-auto"
              : "opacity-0 pointer-events-none"
          }`}
        >
          <div className="flex flex-col gap-8">
            {navLists.map((nav, i) => (
              <a
                key={nav}
                href={`#${nav.toLowerCase()}`}
                className={`text-3xl font-semibold text-white tracking-tight transform transition-all duration-500 ${
                  isMenuOpen
                    ? "translate-x-0 opacity-100"
                    : "-translate-x-10 opacity-0"
                }`}
                style={{ transitionDelay: `${i * 100}ms` }}
                onClick={() => setIsMenuOpen(false)}
              >
                {nav}
              </a>
            ))}
          </div>

          <div className="mt-auto mb-20 space-y-4">
            <p className="text-zinc-500 text-sm italic">
              Innovation meets design.
            </p>
            <div className="w-12 h-px bg-zinc-800" />
            <p className="text-zinc-400 text-xs">© 566dev Studio</p>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
